import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TagPicker } from 'office-ui-fabric-react';
import styles from './PickerField.styles';

const PickerField = ({
  disabled,
  delimiterRegex,
  inputId,
  itemLimit,
  label,
  labelClassName,
  onChange,
  pickerCalloutProps,
  pickerSuggestionsProps,
  removeButtonAriaLabel,
  removeButtonIconProps,
}) => {
  const [selectedItems, setSelectedItems] = useState({});
  const isDuplicateTag = text => selectedItems[text];
  const itemSuggestions = text => {
    if (!text || isDuplicateTag(text)) return [];
    return [{ key: text, name: text }];
  };

  const onChangeItems = items => {
    const changedItems = {};
    items.forEach(item => {
      item.key.split(delimiterRegex).forEach(i => {
        if (i.match(/^$/) || i.match(delimiterRegex)) return;
        changedItems[i] = true;
      });
    });
    setSelectedItems(changedItems);
    onChange(Object.keys(changedItems));
  };

  const inputProps = {};
  if (inputId) inputProps.id = inputId;

  const labelProps = {};
  if (inputId) labelProps.htmlFor = inputId;
  if (labelClassName) labelProps.className = labelClassName;

  return (
    <div className={styles.pickerField}>
      {label && <label {...labelProps}>{label}</label>}
      <TagPicker
        disabled={disabled}
        title="foo bar"
        removeButtonAriaLabel={removeButtonAriaLabel}
        onResolveSuggestions={itemSuggestions}
        getTextFromItem={item => item.name}
        pickerSuggestionsProps={pickerSuggestionsProps}
        removeButtonIconProps={removeButtonIconProps}
        itemLimit={itemLimit}
        pickerCalloutProps={pickerCalloutProps}
        inputProps={inputProps}
        selectedItems={Object.keys(selectedItems).map(item => ({ key: item, name: item }))}
        onChange={onChangeItems}
      />
    </div>
  );
};

PickerField.propTypes = {
  disabled: PropTypes.bool,
  delimiterRegex: PropTypes.instanceOf(RegExp),
  inputId: PropTypes.string,
  itemLimit: PropTypes.number,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  onChange: PropTypes.func,
  pickerCalloutProps: PropTypes.object,
  pickerSuggestionsProps: PropTypes.object,
  removeButtonAriaLabel: PropTypes.string,
  removeButtonIconProps: PropTypes.object,
};

PickerField.defaultProps = {
  disabled: false,
  delimiterRegex: /(;|,|\s+)/,
  inputId: '',
  itemLimit: 100,
  label: '',
  labelClassName: '',
  onChange: () => {},
  pickerCalloutProps: { doNotLayer: true },
  pickerSuggestionsProps: { noResultsFoundText: 'Duplicate Tag' },
  removeButtonAriaLabel: 'Remove',
  removeButtonIconProps: { iconName: 'Delete' },
};

export default PickerField;
